import ajax from "ajax";
import $ from 'jquery';
import tooltip from 'tooltip';
import translate from 'translate';
import confirm from 'confirm';
import ga from "analytics";
import select from "custom-select";
import promptSelect from "prompt-select";
import storage from "storage";
import c from "common";
import programlist from "ohjelmaopas/programlist";
import search from "search";
import resize from "resize";
import scroll from "scroll";
import sidebar from "components/sidebar";

function getSimilarRecordings(matchrule, currentSize) {
  var RECORDING_INCREMENT = 20,
    SIMILAR_RECORDING_URL = "/ohjelmaopas/api/record/similar";

  return ajax.stream({
    url: SIMILAR_RECORDING_URL,
    type: "GET",
    data: {
      rule: matchrule,
      pageSize: RECORDING_INCREMENT,
      offset: currentSize > 0 ? Math.floor((Number(currentSize) + RECORDING_INCREMENT) / RECORDING_INCREMENT) - 1 : 0
    }
  });
}

function getFolders(selected, open) {
  var openParams = (open || []).map(function (id) {
    return "&withOpen=" + id;
  });

  return ajax.stream({
    url: "/tallenteet/api/folders" + (typeof selected === "undefined" ? "" : "?withSelected=" + selected + openParams.join("")),
    type: "GET",
    dataType: "json"
  });
}

function getFolder(id) {
  return ajax.stream({
    url: "/tallenteet/api/folder/" + id,
    type: "GET",
    dataType: "json"
  });
}

function setPin(folderId, pin) {
  return ajax.stream({
    url: "/tallenteet/api/folder/" + folderId + "/pin",
    type: "PUT",
    contentType: "application/json",
    data: JSON.stringify({
      pin: pin
    })
  });
}

function deletePin(folderId) {
  return ajax.stream({
    url: "/tallenteet/api/folder/" + folderId + "/pin",
    type: "DELETE",
    dataType: "text"
  });
}

function toggleRecording(data, object, wildcard) {
  var url = "/tallenteet/api/recordings/";
  if (wildcard) {
    url += "wildcard/";
  }

  return ajax.stream({
    url: url,
    type: object.method,
    contentType: "application/json",
    data: JSON.stringify(data)
  }, function (errorEvent) {
    if (errorEvent.status === 409) {
      // Recording already added, reload program data
      programlist.getProgramById(data.programId).onValue(updateProgram, data);
    } else {
      openErrorTooltip(object.event, errorEvent);
      $(object.event.target).toggleClass("disabled progress", false);
    }
  });
}

function updateProgram(data, jsonData) {
  if (jsonData && $("body").hasClass("ohjelmaopas")) {
    programlist.updateOnRec(data, jsonData);
  }
  if (jsonData && $(".search-tabs").length > 0) {
    search.updateSearchAfterRecording(data, jsonData);
  }
  if (jsonData && $("body").hasClass("index")) {
    programlist.updateQuickRecForPrograms(jsonData, $('.popular-recording'));
  }
}

function openErrorTooltip(event, errorEvent) {
  var title = translate('add-recording-failed');
  var msg;
  if (errorEvent.status === 403) {
    msg = translate('session-expired');
  } else if (errorEvent.status === 404) {
    msg = translate('no-connection');
  } else if (errorEvent.status === 507) {
    msg = translate('quota-full');
  } else if (errorEvent.status === 410) {
    msg = translate('program-ended');
  } else if (errorEvent.status === 422) {
    msg = translate('duplicate-wildcard');
  } else {
    msg = translate('server-error');
  }
  var $target = $(event.target);
  $target.qtip({
    id: 'recording-error',
    position: {
      my: 'bottom center',
      at: 'top center',
      viewport: $(window),
      target: $target
    },
    overwrite: true,
    content: '<div class="ohjelmaopas-error-qtip"><div>' + title + "<p>" + msg + "</p></div></div>",
    show: {
      ready: true,
      solo: true,
      event: event.type
    },
    hide: {
      fixed: true,
      event: 'unfocus click'
    },
    events: {
      hide: function () {
        $target.css("display", "");
        return $target.qtip('destroy');
      }
    }
  }, event);
}

function getRecordings(query) {
  return ajax.stream({
    url: "/tallenteet/api/recordings/" + query.folderId + "?" + $.param(query.parameters),
    type: "GET",
    dataType: "json"
  });
}

function initRecordingTooltips(element) {
  element.asEventStream('mouseover', '.isWatched, .isRecorded').onValue(function (event) {
    tooltip.show(event, $(event.target).attr('title'));
  });
  $(document.body).asEventStream('mouseover', '.compact .program-title').onValue(function (event) {
    tooltip.show(event, $(event.target).siblings("a.description").text(), {
      position: {
        my: 'bottom center',
        at: 'top center'
      }
    });
  });
}

function getSortingData(localStorageName, $toolbar, defaultSort) {
  var $selectedSort = $(".sort.selected"),
    savedSort = storage.getObject(localStorageName),
    sort = {};

  if ($selectedSort.length > 0) {
    sort.sortBy = $selectedSort.attr("data-sort-by");
    sort.sortOrder = $toolbar.attr("data-sort-order");
  } else if (savedSort) {
    sort = savedSort;
  } else {
    sort = defaultSort;
  }
  return sort;
}

function getWildcards(data) {
  return ajax.stream({
    type: "GET",
    url: "/tallenteet/api/recordings/wildcards",
    dataType: "json",
    data: data
  });
}

function isWildcardValid(value) {

  if (value.trim().match("^([^\\*]$|.?[^\\*]{2,253}.?)$") === null) {

    return false;
  }
  return true;
}

function getProgramId(program) {
  return program.programId;
}

function deleteRecordings(programs) {
  return ajax.stream({
    type: "DELETE",
    url: "/tallenteet/api/recordings/" + programs.map(getProgramId).join(","),
    dataType: "text"
  });
}

function confirmDelete(items) {
  return confirm.open({
    confirmList: items,
    template: "confirm-modal",
    howManyMore: items.length - 10 < 0 ? 0 : items.length - 10
  }).map(items);
}

function setChecked(i, e) {
  if ($(e).parent().is(":visible")) {
      $(e).prop('checked', true).parent().addClass('selected');
  }
}

function setUnchecked(i, e) {
  $(e).prop('checked', false).parent().removeClass('selected');
}

function massCheck(selected) {
  switch (selected) {
    case "all":
      $('input[name="selected-recording"]').each(setChecked);
      ga.trackWithSection("massCheck", "all");
      break;
    case "none":
      $('input[name="selected-recording"]:checked').each(setUnchecked);
      ga.trackWithSection("massCheck", "none");
      break;
    case "unwatched":
      $('.recording[data-watched="true"] input[name="selected-recording"]:checked').each(setUnchecked);
      $('.recording[data-watched="false"] input[name="selected-recording"]').each(setChecked);
      ga.trackWithSection("massCheck", "unwatched");
      break;
    case "duplicates":
      $('.recording[data-duplicate="false"] input[name="selected-recording"]:checked').each(setUnchecked);
      $('.recording[data-duplicate="true"] input[name="selected-recording"]').each(setChecked);
      ga.trackWithSection("massCheck", "duplicates");
      break;
    case "watched":
      $('.recording[data-watched="false"] input[name="selected-recording"]:checked').each(setUnchecked);
      $('.recording[data-watched="true"] input[name="selected-recording"]').each(setChecked);
      ga.trackWithSection("massCheck", "watched");
      break;
  }
}

function getCheckboxStates() {
  var checked = document.querySelectorAll('[name="selected-recording"]:checked').length;
  var total = document.querySelectorAll('[name="selected-recording"]').length;
  return checked === 0 ? select.states.UNCHECKED : checked !== total ? select.states.INDETERMINATE : select.states.CHECKED;
}

function flattenFolders(folders) {
  return folders.reduce(function (arr, folder) {
    return arr.concat([folder].concat(flattenFolders(folder.folders)));
  }, []);
}

function promptMove(items) {
  return promptSelect.open({
    options: items
  });
}

function getSelectedRecordings() {
  return [].slice.call(document.querySelectorAll('[name="selected-recording"]:checked'), 0).map(function (node) {
    return {
      programId: node.value,
      name: $(node).parent().attr('data-name'),
      watched: $(node).parent().attr('data-watched') === "true"
    };
  });
}

function moveRecordings(folderId) {
  return ajax.stream({
    type: "PUT",
    url: "/tallenteet/api/recordings/move/" + getSelectedRecordings().map(getProgramId).join(",") + "?folderId=" + folderId,
    dataType: "text"
  });
}

function storeSelectedRecordingsState() {
  var selectedRecordings = getSelectedRecordings();
  storage.setSessionObject("selectedRecordings", selectedRecordings);
}

function toggleRecordingActions(state) {
  $('.recording-action').toggle(state !== select.states.UNCHECKED);
}

function tickPreviouslyCheckedCheckboxes() {
  var previouslySelected = storage.getSessionObject("selectedRecordings");
  $('input[name="selected-recording"]').each(setUnchecked);
  if (previouslySelected) {
    previouslySelected.forEach(function (value) {
      if (value) {
        $("#recording-" + value.programId).prop('checked', true).parent().toggleClass('selected', true);
      }
    });
  }
}

function currentPage() {
  var page = parseInt($('#current-page').text(), 10);
  return isNaN(page) ? 1 : page;
}

function nextPage(x) {
  return x + currentPage();
}

function totalPages() {
  return parseInt($('#total-pages').text(), 10);
}

function updatePagingStatus(page) {
  var total = totalPages();
  page = page <= total ? page : total;

  $('#current-page').text(page);
  $('#previous-page').toggleClass('disabled', page === 1);
  $('#next-page').toggleClass('disabled', page === total);
}

function watchedStatus() {
  return $('#recordings-view-filter').val();
}

function createPageSelectionStream() {

  var nextPageStream = $('#next-page').asEventStream('click').doAction(c.stopEvent).map(1);

  var previousPageStream = $('#previous-page').asEventStream('click').doAction(c.stopEvent).map(-1);

  var pageSelectionStream = nextPageStream.merge(previousPageStream).map(nextPage).filter(function (page) {
    return page > 0 && page < totalPages() + 1;
  });

  pageSelectionStream.onValue(function (page) {
    ga.trackWithSection("page-change", page);
  });
  return pageSelectionStream;
}

function isDefaultSort(sort) {
  return sort.sortOrder === "desc" && sort.sortBy === "startTime";
}

function setSelectedSorting($toolbar) {
  var sortBy = $toolbar.attr("data-sort-by");
  $toolbar.find(".sort[data-sort-by=" + sortBy + "]").addClass("selected");
}

function goToFolder(folder) {
  var folderId = folder.attr("data-id"),
    url = "/tallenteet/kansio/" + folderId + "/sivu/1";
  if (folderId) {
    document.location = url;
  }
}

function sidebarFolderStream() {
  var $recordingsSidebar = $('#recordings-sidebar');
  $recordingsSidebar.asEventStream('click', ' .navitem-parent .navitem-open').doAction(c.stopEvent).map(c.$currentTarget).onValue(function ($target) {
    $target.closest('.navitem').toggleClass('navitem-opened');
    $target.closest('.navitem-container').find('.navitem-group:first').toggleClass('navitem-group-opened');
  });
  $recordingsSidebar.asEventStream('click', '.recordings-folder').doAction(c.stopEvent).map(c.$currentTarget).onValue(goToFolder);
}

function deleteRecording(recording) {
  var recordingId = recording[0].id;
  ga.trackWithSection("delete-recording", recordingId);
  return ajax.stream({
    type: "DELETE",
    url: "/tallenteet/api/recordings/id/" + recordingId,
    dataType: "text"
  });
}

function resizeRecordingToolbar() {
  // $('#recordings-toolbar-floating-section').css('width', $('.recordings-list').width() - 1 + 'px');
}

function initRecordingsLayout() {
  const initialToolbarOffset = $('#recordings-toolbar-floating-section').offset();
  var compactStream = scroll.window.map(function (val) {
    return initialToolbarOffset && val > initialToolbarOffset.top;
  }).skipDuplicates();

  compactStream.onValue(function (val) {
    $('#recordings-sidebar, #recordings-toolbar, .recordings-list').toggleClass('compact-toolbar', val);
  });

  resize.stream.onValue(function () {
    resizeRecordingToolbar();
  });

  resizeRecordingToolbar();
  sidebar.init();
}

function updateSortingOrder($sortingToolbar, storeObjectName, $target) {
  var sortOrder = $sortingToolbar.attr("data-sort-order");

  if ($target.hasClass("selected")) {
    $sortingToolbar.attr("data-sort-order", sortOrder === "desc" ? "asc" : "desc");
  } else {
    $(".sort").removeClass("selected");
    $target.addClass("selected");
    $sortingToolbar.attr("data-sort-order", "asc");
  }
  $sortingToolbar = $($sortingToolbar.selector);

  storage.setObject(storeObjectName, {
    sortOrder: $sortingToolbar.attr("data-sort-order"),
    sortBy: $target.attr("data-sort-by")
  });
}

function initialShowDescriptions() {
  var showDescriptions = storage.get('showRecordingDescriptions') === null || storage.get('showRecordingDescriptions') === "true";
  $('#show-descriptions').prop('checked', showDescriptions);
  return showDescriptions;
}

function setShowDescriptions(val) {
  storage.set('showRecordingDescriptions', val);
  $('.recordings-list').toggleClass('compact', !val);
}

function initShowDescriptionProperty() {
  $('#show-descriptions').asEventStream('change')
    .map(c.$target)
    .map(function ($target) {
      ga.trackWithSection("showRecordingDescriptions", $target.is(':checked'));
      return $target.is(':checked');
    })
    .toProperty(initialShowDescriptions())
    .onValue(setShowDescriptions);
}

function getScheduledRecordings(data) {
  return ajax.stream({
    url: "/tallenteet/api/recordings/scheduled",
    type: "GET",
    data: data
  });
}

function getDuplicateRecordings(data) {
    var returnValue = ajax.stream({
        url: "/tallenteet/api/recordings/duplicates",
        type: "GET",
        data: data
    });
    return returnValue;
}

function getContinueWatchingRecordings(data) {
    var returnValue = ajax.stream({
        url: "/tallenteet/api/recordings/jatka-katsomista",
        type: "GET",
        data: data
    });
    return returnValue;
}

function highlightExpireInWeekOrLess() {
  $('*[data-expire-in]').filter(function(index, element) {
      var today = new Date();
      var expireIn = $(element).data('expire-in');
      if (expireIn.length === 0) {
        return false;
      }
      return expireIn <= today.setDate(today.getDate() + 7);
  }).addClass('expiring-soon');
}

export default {
  folders: getFolders,
  recordings: getRecordings,
  getSimilarRecordings: getSimilarRecordings,
  makeRecordings: toggleRecording,
  tooltips: initRecordingTooltips,
  folder: getFolder,
  setPin: setPin,
  deletePin: deletePin,
  openErrorTooltip: openErrorTooltip,
  getWildcards: getWildcards,
  getSortingData: getSortingData,
  isWildcardValid: isWildcardValid,
  confirmDelete: confirmDelete,
  deleteRecordings: deleteRecordings,
  getProgramId: getProgramId,
  updateProgram: updateProgram,
  setChecked: setChecked,
  massCheck: massCheck,
  getCheckboxStates: getCheckboxStates,
  flattenFolders: flattenFolders,
  promptMove: promptMove,
  moveRecordings: moveRecordings,
  getSelectedRecordings: getSelectedRecordings,
  toggleRecordingActions: toggleRecordingActions,
  storeSelectedRecordingsState: storeSelectedRecordingsState,
  tickPreviouslyCheckedCheckboxes: tickPreviouslyCheckedCheckboxes,
  createPageSelectionStream: createPageSelectionStream,
  currentPage: currentPage,
  totalPages: totalPages,
  updatePagingStatus: updatePagingStatus,
  watchedStatus: watchedStatus,
  isDefaultSort: isDefaultSort,
  setSelectedSorting: setSelectedSorting,
  sidebarFolderStream: sidebarFolderStream,
  deleteRecording: deleteRecording,
  initRecordingsLayout: initRecordingsLayout,
  resizeRecordingToolbar: resizeRecordingToolbar,
  updateSortingOrder: updateSortingOrder,
  initShowDescriptionProperty: initShowDescriptionProperty,
  getScheduledRecordings: getScheduledRecordings,
  getDuplicateRecordings: getDuplicateRecordings,
  getContinueWatchingRecordings: getContinueWatchingRecordings,
  highlightExpireInWeekOrLess: highlightExpireInWeekOrLess
};



// WEBPACK FOOTER //
// ./web/js/recordings.js